import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { SiHyperledger } from "react-icons/si";
import "jspdf-autotable";
import { errorAlert } from "../../Components/Alerts";
import DataGridComponent from "../../Components/DataGridComponent";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";
const currencyFormatter = new Intl.NumberFormat('en-US', {
    // style: 'currency',
    // currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});



export default function JournalHistory() {
    const [data, setData] = useState([]);
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);

    const columns = [
        { field: 'id', headerName: '#', width: 110, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'actionType', headerName: 'Tipi Veprimit', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'ledger', headerName: 'Llogaria Kontabel', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'date', headerName: 'Data', type: 'string', width: 130, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        {
            field: 'debit', headerName: 'Debi', type: 'string', width: 130, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
        },
        {
            field: 'credit', headerName: 'Kredi', type: 'string', width: 130, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
        },
        {
            field: 'balance', headerName: 'Bilanci', type: 'string', width: 130, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
        },
        { field: 'comment', headerName: 'Komenti', type: 'string', width: 300, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    ];

    const totalDebit = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Debit), 0);
    }, [data]);

    const totalCredit = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Credit), 0);
    }, [data]);

    const totalBalance = useMemo(() => {
        return data.reduce((sum, item) => sum + ((Number(item.Debit) - Number(item.Credit))), 0);
    }, [data]);

    const rows = data.map((item) => ({
        id: item.JournalID,
        actionType: item.ActionType,
        ledger: item.LedgerNameEN,
        date: item.Date,
        debit: item.Debit,
        credit: item.Credit,
        balance: item.Balance,
        comment: item.Comment,
        className: item.Balance === 0 ? 'zero-balance-row' : 'non-zero-balance-row', // Shto klasën CSS bazuar në vlerën e 'balance'
    }));

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Reports/journalHistory', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
            // setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, [fiscalYear]);

    return (
        <div className="Crud__Container">
            <TitleElements
                icon={SiHyperledger}
                title="Ditari i Transaksioneve"
            />
            <ElementsParagraph text="Ky format i Ditarit është i përshtatur për të vërifikuar transaksionet." />


            <div className="bordere">
                <div className="butonss">
                </div>
            </div>
            <DataGridComponent columns={columns} rows={rows} />
            <TotalSummaryComponent
                fields={[
                    { id: 1, label: 'Debi', value: totalDebit },
                    { id: 2, label: 'Kredi', value: totalCredit },
                    { id: 3, label: 'Bilanci', value: totalBalance },
                ]}
            />
        </div>
    )
}